export const registerPlugins = ({ app, plugins }) => {
  plugins.forEach((plugin) => {
    if (Array.isArray(plugin)) app.use(plugin[0], plugin[1]);
    else app.use(plugin);
  });

  return app;
};
